export const FETCH_STOCK_MOVEMENTS_SUCCESS = "FETCH_STOCK_MOVEMENTS_SUCCESS";
export const FETCH_STOCK_MOVEMENTS_BEGIN = "FETCH_STOCK_MOVEMENTS_BEGIN";
export const FETCH_STOCK_MOVEMENTS_FAILURE = "FETCH_STOCK_MOVEMENTS_FAILURE";

export const UPDATE_STOCK_MOVEMENT_STATUS_SUCCESS =
  "UPDATE_STOCK_MOVEMENT_STATUS_SUCCESS";
export const UPDATE_STOCK_MOVEMENT_STATUS_FAILURE =
  "UPDATE_STOCK_MOVEMENT_STATUS_FAILURE";
export const UPDATE_STOCK_MOVEMENT_STATUS_BEGIN =
  "UPDATE_STOCK_MOVEMENT_STATUS_BEGIN";
